// eslint-disable-next-line no-restricted-imports
import {
  FileFragment,
  Query_ClientController_GetList_AllOf_1_List_Items_Representative_TaxResidences_Items_Documents_Items_CreatedBy_Type as CreatedByType,
} from 'api/generated/graphql';
import { FileEntity, FileTypeName } from 'api/types/entity';

type FileApi = FileFragment & { type?: FileTypeName };

export const parseFileEntity = (v: FileApi): FileEntity => ({
  id: v.id,
  name: v.name,
  size: v.size,
  createdAt: new Date(v.createdAt),
  type: v.type,
});

interface Args {
  privateFile: FileApi;
  createdBy: {
    type: CreatedByType;
  };
}

export const parseFileDocumentEntity = (d: Args): FileEntity => ({
  ...parseFileEntity(d.privateFile),
  uploadedByAdmin: d.createdBy.type === CreatedByType.AdminUser,
});
